<div class="create-service">
  <form [formGroup]="serviceTicketFormGroup" (ngSubmit)="submitRequest()">
    <div class="flex-grid">
      <div class="create-service__col fx--flex1">
        <h4 l10nTranslate>core.tellusAboutIssue</h4>
        <label class="form-label" l10nTranslate>core.issueTitle<span class="required">*</span></label>
        <mat-form-field appearance="outline" class="issue-title-input">
          <input
            matInput
            autocomplete="no-autofill"
            placeholder="{{ 'core.enterIssueTitle' | xTranslate }}"
            formControlName="ticketName"
          />
          <mat-error *ngIf="serviceTicketFormGroup.controls.ticketName.errors?.required" l10nTranslate>
            core.titleRequired
          </mat-error>
          <mat-error *ngIf="serviceTicketFormGroup.controls.ticketName.errors?.maxlength" l10nTranslate>
            core.titleSizeLimit
          </mat-error>
        </mat-form-field>
        <label class="form-label" l10nTranslate>core.issueDesc<span class="required">*</span></label>
        <mat-form-field appearance="outline" class="issue-description-input">
          <textarea
            autocomplete="no-autofill"
            matInput
            placeholder="{{ 'core.enterIssueDesc' | xTranslate }}"
            formControlName="description"
          >
          </textarea>
          <mat-error *ngIf="serviceTicketFormGroup.controls['description'].errors?.required" l10nTranslate>
            core.shotDescReq
          </mat-error>
        </mat-form-field>
        <h4 class="add-attachment" l10nTranslate>core.addAttachment</h4>
        <input
          type="file"
          #fileImportInput
          name="file"
          placeholder="{{ 'core.browse' | xTranslate }}"
          id="file"
          class="inputfile"
          data-multiple-caption="{count} files selected"
          accept="image/*,audio/*,video/*,.pdf,.doc,.docx ,.ppt,.pptx,.pps,.ppsx,.odt,.xls,.xlsx,.zip"
          (change)="onFileChange($event)"
        />
        <label for="file">
          {{
            fileList.length > 1
              ? fileList.length.toString() + ('core.fileSelected' | xTranslate)
              : ('core.browse' | xTranslate)
          }}</label
        >
        <div class="attachment-container">
          <div class="attacment-list" *ngFor="let file of fileList">
            <div class="attachment-file">
              <mat-icon>attachment</mat-icon>
              <div>{{ file.name }}</div>
              <mat-icon (click)="removeFile(file.name)">close</mat-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="create-service__col fx--flex3">
        <mat-checkbox class="help-chk-label" formControlName="screenshotAttachment" l10nTranslate>
          core.attachScreenshot
        </mat-checkbox>
        <div #attachment id="attachment"></div>
      </div>
    </div>
    <div class="actions">
      <button type="submit" value="submit" mat-flat-button color="primary" l10nTranslate>core.submit</button>
    </div>
  </form>
</div>
